module.exports = __webpack_public_path__ + "static/media/hero.e85b1b47.jpg";